var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 218,
    viewBox: "0 0 202 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.772 19.1745C202.772 14.8419 202.772 7.8183 198.772 3.48562C194.772 -0.845469 188.283 -0.845469 184.283 3.48562L101.363 93.2627L18.444 3.48562C14.4422 -0.845469 7.95511 -0.845469 3.95335 3.48562C-0.0469493 7.8183 -0.0469493 14.8419 3.95335 19.1745L86.8735 108.95L3.95335 198.727C-0.0469493 203.058 -0.0469493 210.083 3.95335 214.414C7.95511 218.746 14.4422 218.746 18.444 214.414L101.363 124.639L184.283 214.413C188.283 218.746 194.772 218.746 198.772 214.413C202.772 210.083 202.772 203.058 198.772 198.727L115.853 108.95L198.772 19.1745Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/delete-button.325230347cea58d44fea2484a8408648.svg";
export { ForwardRef as ReactComponent };